































import { Component, Mixins } from "vue-property-decorator";
import HashVerificationMixin from "@/mixins/hashVerificationMixin";

@Component
export default class AdminVerify extends Mixins(HashVerificationMixin) {
  // Data
  public hasError = false;

  // Life-cycle methods
  public async created() {
    await this.initHashVerification();
    this.completeRegistration();
  }

  // Computed
  public get hasErrored() {
    return this.hash.isExpiredOrInvalid || this.hasError;
  }

  // Methods
  private async completeRegistration() {
    if (this.hash.isExpiredOrInvalid) return;
    try {
      // Complete registration
      await this.$store.dispatch("auth/admin/completeOrgRegistration", {
        reg_hash: this.reg_hash,
        username: this.username
      });
      // Open toast
      this.$buefy.toast.open({
        message: this.$t(
          "_sentence.account_activation_was_successful"
        ) as string
      });
    } catch (error) {
      this.hasError = true;
      this.$store.dispatch("api/handleError", error);
    }
  }
}
